import { useContext } from "react";
import { DataContext } from '../contexts/CommonContext'

const useCommonContext = () => {
   const context = useContext(DataContext);

   if (!context)
      throw new Error("useCommonContext must be use inside CommonContextProvider");

   return context;
};

export default useCommonContext;
